import { ChartWidgetType } from '@/components/Metrics/config'

import { NameDto } from '../../Common/Types'

export enum IntervalType {
  Daily = 1,
  Monthly = 2,
  Yearly = 3,
}

interface MetricsDto {
  startDate: string
  endDate: string
  intervalType: NameDto
}

export interface MetricsCountDto extends MetricsDto {
  count: number
}

export interface MetricsNVDto extends MetricsDto {
  notionalVolumeUsd: number
}

export interface MetricsLotsDto extends MetricsDto {
  lots: number
}

export interface MetricsDepositsDto extends MetricsDto {
  totalDeposits: number
}

export interface MetricsNetDepositsDto extends MetricsDto {
  totalNetDeposits: number
}

export interface MetricsIBCommissionsDto extends MetricsDto {
  commission: number
}

export interface MetricsQueryParams {
  from: string
  to: string
  introducingBrokerIds?: string[]
  countryIds?: string[]
  intervalType?: IntervalType
}

export interface MetricsWidgetProps {
  type?: ChartWidgetType
  introducingBrokerIds?: string[]
  countryIds?: string[]
  customDateRange?: [string, string]
  intervalType?: number
}
